import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TacticalLiaison } from '../../shared/services/tactical-liaison.service';
import { ViewableRequest } from '../review-request/review-request.model';
import { Sources } from '../../shared/services/request-comments.service';

@Component({
  selector: 'app-request-assignment-modal',
  templateUrl: './request-reassignment-modal.component.html',
  styleUrls: ['./request-reassignment-modal.component.css']
})
export class RequestReAssignmentModalComponent implements OnInit {

  public request: ViewableRequest;
  public tacticalLiaisons : TacticalLiaison[] = [];
  public initialTacticalLiaisonId: number;
  public assignmentForm: FormGroup;

  public onClose: Subject<any> = new Subject<any>();
  public onReAssigned: Subject<ReAssignmentModel> = new Subject<ReAssignmentModel>();

  constructor(private modalRef: BsModalRef, formBuilder: FormBuilder) { 
    this.assignmentForm = formBuilder.group({
      tacticalLiaison: formBuilder.control(this.initialTacticalLiaisonId, [ Validators.required ])
    });
  }

  ngOnInit() {
    this.assignmentForm.controls['tacticalLiaison'].setValue(this.initialTacticalLiaisonId);
  }

  public closeModal(): void {
    this.modalRef.hide();
  }

  public reAssignRequest(): void {
    var formData = this.assignmentForm.value as ReAssignmentFormModel;

    this.onReAssigned.next({
      requestId: this.request.id,
      tacticalLiaisonId: formData.tacticalLiaison
    });
  }
}

export interface ReAssignmentModel {
  requestId: number;
  tacticalLiaisonId: number;
}

interface ReAssignmentFormModel {
  tacticalLiaison: number;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-reassignment-modal/request-reassignment-modal.component.ts